import React from 'react'
import PropTypes from 'prop-types'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { generateUrls, useRelations } from '@hooks/useServiceProduct'

const ServiceProductListItem = (props) => {
  const { serviceProduct, serviceProduct: { id, title } } = props

  const { editServiceProductRelationsUrl } = generateUrls(serviceProduct)

  const { service } = useRelations(serviceProduct)

  return (
    <DashboardModuleListItem
      href={editServiceProductRelationsUrl}
      secondaryText={service.title}
      title={title}
    >
      <DashboardModuleListItem.TertiaryText>
        # {id}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

ServiceProductListItem.propTypes = {
  serviceProduct: PropTypes.object.isRequired,
}

export default ServiceProductListItem
